<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" :disabled="$hasExtraModule('equipment') != 'active'" />

        <action-button
          type="delete"
          @click="del(equipmenttype.id)"
          v-if="equipmenttype.id && $can('equipment-access') && modal != true"
          :disabled="$hasExtraModule('equipment') != 'active'"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipmenttype.name"
                  v-model="equipmenttype.name"
                  v-validate="'max:50'"
                  :label="$t('equipmenttypes.name')"
                  :error-messages="errors.collect('equipmenttype.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-combobox
                  name="equipmenttype.equipment_category_id"
                  v-model="selectedEquipmentCategory"
                  class="required-field"
                  v-validate="'required'"
                  item-text="name"
                  item-value="id"
                  :items="equipmentcategories"
                  :label="$t('equipmentcategories.stitle')"
                  :error-messages="errors.collect('equipmenttype.equipment_category_id')"
                  v-on:keyup.enter="equipmentCategoryOnEnter"
                  @blur="equipmentCategoryOnBlur"
                  clearable
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <span class="subheading">{{ $t("global.no_data_create") }}</span>
                    </v-list-item>
                  </template></v-combobox
                >
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="equipmenttype.inspection_interval"
                  v-model="equipmenttype.inspection_interval"
                  item-text="text"
                  item-value="key"
                  :items="$dd_inspection_interval()"
                  :label="$t('equipmenttypes.inspection_interval')"
                  :error-messages="errors.collect('equipmenttype.inspection_interval')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="equipmenttype.status"
                  v-model="equipmenttype.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_task_status()"
                  :label="$t('tasks.status')"
                  :error-messages="errors.collect('equipmenttype.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EquipmentTypeForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      equipmenttype: {},
      selectedEquipmentCategory: null,
      equipmentcategories: [],
      dictionary: {
        attributes: {
          "equipmenttype.name": this.$t("equipmenttypes.name"),
          "equipmenttype.inspection_interval": this.$t("equipmenttypes.inspection_interval"),
          "equipmenttype.equipment_category_id": this.$t("equipmentcategories.stitle"),
          "equipmenttype.status": this.$t("equipmenttypes.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$hasExtraModule("equipment") == "active") {
      this.$validator.validateAll().then(() => {
        this.$leaveFormConfirmation(next, this.equipmenttype, this.predata, this.save, this.isFormValid)
      })
    } else {
      next()
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("equipmenttypes.new_title")
      this.equipmenttype = {
        status: this.$getDefaultDropdown(this.$dd_task_status())
      }
      this.selectedEquipmentCategory = null

      this.predata = JSON.parse(JSON.stringify(this.equipmenttype))
      this.ddlist()
    } else {
      axios
        .get(this.API_URL + "equipment-type/" + this.id)
        .then((res) => {
          this.equipmenttype = res.data.data
          this.predata = JSON.parse(JSON.stringify(this.equipmenttype))
          this.ddlist()

          this.page_title = this.$t("equipmenttypes.edit_title", {
            name: this.equipmenttype.name
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    ddlist() {
      axios.get(this.API_URL + "equipment-categories?show_all=true").then((res) => {
        this.equipmentcategories = res.data.data

        if (this.id) {
          this.selectedEquipmentCategory = this.equipmentcategories.find((i) => i.id == this.equipmenttype.equipment_category_id)
        }
      })
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.equipmenttype.id) {
              // Create
              axios
                .post(this.API_URL + "equipment-type", {
                  name: this.equipmenttype.name,
                  equipment_category_id: this.selectedEquipmentCategory.id || null,
                  inspection_interval: this.equipmenttype.inspection_interval,
                  status: this.equipmenttype.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.equipmenttype = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.equipmenttype))

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "equipmenttypes",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = this.$t("equipmenttypes.edit_title", {
                          name: vm.equipmenttype.name
                        })
                        vm.$router.replace(this.BACKEND_URL + `/equipment-types/edit/${vm.equipmenttype.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "equipment-type", {
                  id: this.equipmenttype.id,
                  name: this.equipmenttype.name,
                  equipment_category_id: this.selectedEquipmentCategory.id || null,
                  inspection_interval: this.equipmenttype.inspection_interval,
                  status: this.equipmenttype.status
                })
                .then((res) => {
                  vm.equipmenttype = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.equipmenttype))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "equipmenttypes",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "equipment-type/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/equipment-types")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    equipmentCategoryOnBlur(e) {
      let val = this.selectedEquipmentCategory

      if (typeof val === "string" && val) {
        this.selectedEquipmentCategory = null
      }
    },
    equipmentCategoryOnEnter(e) {
      let val = this.selectedEquipmentCategory

      if (e.keyCode == 13) {
        if (typeof val === "string" && val) {
          let user = this.$store.getters["auth/user"]
          let obj = {
            name: val,
            status: 1,
            created_by: user.id
          }
          let exist = this.equipmentcategories.find((i) => i.name == val)

          if (!exist) {
            // Add new equipment category
            axios
              .post(this.API_URL + "equipment-category", obj)
              .then((res) => {
                this.equipmentcategories.push(res.data.data)
                this.selectedEquipmentCategory = res.data.data
                this.$awn.success(this.$t("global.create_success"))
              })
              .catch((error) => {
                this.$handleServerSideError(error)
              })
          } else {
            this.selectedEquipmentCategory = exist
          }
        }
      }
    }
  }
}
</script>

<style scoped></style>
